import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { authActions, alertActions } from '../../store/actions';
import Footer from '../../components/Footer/footer';
import { history } from '../../helpers/history';
import Swal from 'sweetalert2';
import '../../static/css/styles.css';
import { forgorPassword } from '../../helpers/ConstantID';
import { constants } from '../../Constants';
import { contactUsEmail } from '../../config';
import defaultImage from '../../static/images/default_BG.png';

class EmailVerification extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email_address: '',
			submitted: false,
			is_mobile: false,
			error: '',
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	handleChange(e) {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	}

	componentDidMount() {
		window.innerWidth <= 700 ? this.setState({ is_mobile: true }) : this.setState({ is_mobile: false });
		// clear alert on location change
		const { dispatch } = this.props;
		dispatch(alertActions.clear());
	}

	handleSubmit(ev) {
		ev.preventDefault();
		this.setState({ submitted: true });
		const { email_address } = this.state;
		const { dispatch } = this.props;

		if (email_address === '') this.setState({ error: 'Please enter email address' });
		else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email_address)) {
			this.setState({ error: '' });
			dispatch(authActions.forgotPasswordEmail(email_address));
		} else {
			Swal.fire('Invalid Email', 'You have entered an invalid email address!', 'warning');
		}
	}
	login = () => {
		history.replace('/');
	};
	register = () => {
		history.push('/registration');
	};
	render() {
		const { alert, whitelabel } = this.props;
		const { error, email_address } = this.state;
		const showError = error !== '';
		return (
			<div className="sh-layout">
				<div className="sh-forgot-pass-comp">
					<div className="sh-gnrl-inner">
						<div className="sh-gnrl-logo">
							<img
								src={whitelabel ? whitelabel[0].logo_url : defaultImage}
								alt="logo"
								id={forgorPassword.sh_fp_logo}
							/>
						</div>
						<div className="sh-fpc-heading">
							<h2 className="sh-fpc-h2 sh-mb-15" id={forgorPassword.sh_fp_text1}>
								{constants.FORGOT_PASSWORD_MSG}
							</h2>
							<p className="sh-fpc-gnrl-text sh-mb-20" id={forgorPassword.sh_fp_text2}>
								{constants.EMAIL_VERIFY_TXT}
							</p>
						</div>
						<div className="sh-fpc-form">
							<div className="sh-gnrl-row sh-mb-5">
								<div className="sh-input-group">
									<input
										autoComplete="off"
										id={forgorPassword.sh_fp_email}
										value={email_address || ''}
										required
										type="email"
										name="email_address"
										onChange={this.handleChange}
										className={`sh-input-text ${showError ? 'sh-input-error' : ''}`}
									/>
									<label htmlFor={forgorPassword.sh_fp_email} className="sh-input-label">
										{constants.EMAIL_ADDRESS}
									</label>
								</div>
							</div>
							<div className="sh-grnl-row sh-mb-15">
								<span className="sh-gnrl-error-msg">{error}</span>
							</div>

							<div className="sh-gnrl-row sh-mb-10">
								<button
									id={forgorPassword.sh_fp_btn}
									className="sh-gnrl-btn sh-login-btn"
									onClick={this.handleSubmit}
								>
									{constants.FORGOT_PASS_BTN}
								</button>
							</div>

							<div className="sh-gnrl-row">
								<label htmlFor={forgorPassword.sh_fp_cs_btn} className="sh-fpc-cnslr">
									{constants.NEED_HELP_TXT}{' '}
									<a className="mobile-contact-help" href={`mailto:${contactUsEmail}`}>
										{constants.CUSTOMER_SUPPORT_TXT}
									</a>
								</label>
							</div>
						</div>
					</div>
				</div>

				<Footer />
			</div>
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	const { authstate } = state.auth;
	const { whitelabel } = state.whitelabel;
	return {
		alert,
		authstate,
		whitelabel,
	};
}

export default withRouter(connect(mapStateToProps)(EmailVerification));



// WEBPACK FOOTER //
// ./src/screens/EmailVerification/index.js